import React, { useState, useEffect } from 'react'; // Removed useCallback
import './CreateUsers.css';
import Notification from '../../Notification/Notification'; // Az notification importálása
import { Modal } from 'antd';
import ChangePassword from '../../ChangePassword/ChangePassword';

const apiUrl = process.env.REACT_APP_API_URL;

function CreateUsers({ selectedUser, onSaveSuccess, onCancel }) {
  const [newUser, setNewUser] = useState({ name: '', password: '', fullname: '', email: '', level: 0 });
  const [confirmPassword, setConfirmPassword] = useState(''); // Jelszó megerősítés állapota
  const [passwordMatch, setPasswordMatch] = useState(true); // Új állapot az egyezés ellenőrzésére
  const [loading, setLoading] = useState(false); // Új állapot a betöltés jelzésére
  const [changedCancelToClose, setChangedCancelToClose] = useState(false);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isFormModified, setIsFormModified] = useState(false); // Új állapot a form módosításának nyomon követésére
  const [token] = useState(localStorage.getItem('token') || '');
  const [notification, setNotification] = useState({ message: '', type: '' });
  const level = localStorage.getItem('level');

  useEffect(() => {
    setPasswordMatch(newUser.password === confirmPassword);
  }, [newUser.password, confirmPassword]);

  // Ha kapunk egy selectedUser-t, akkor kitöltjük a mezőket a meglévő adatokkal (szerkesztéshez)
  useEffect(() => {
    if (selectedUser) {
      setNewUser(selectedUser);
      setEditMode(true);
    } else {
      setEditMode(false);
    }
  }, [selectedUser]);

  // Ha bármelyik mező változik, akkor isFormModified true-ra vált
  useEffect(() => {
    if (editMode) {
      const isModified =
        selectedUser?.name !== newUser.name ||
        selectedUser?.fullname !== newUser.fullname ||
        selectedUser?.email !== newUser.email ||
        selectedUser?.level !== newUser.level;
      setIsFormModified(isModified);
    } else {
      setIsFormModified(
        newUser.name !== '' &&
        newUser.fullname !== '' &&
        newUser.email !== '' &&
        newUser.level !== 0
      );
    }
  }, [newUser, editMode, selectedUser]);

  const onChangePassword = () => {
    // Itt implementálhatod a jelszó módosítás logikáját, például megnyithatsz egy modált vagy átirányíthatsz egy másik oldalra
    setIsChangePassword(true);
  }

  const handleClose = (param) => {
    setIsChangePassword(false);
    if (param === 1) {
      setChangedCancelToClose(true);
    }

  }

  // Kategória létrehozása vagy szerkesztése
  const handleSaveUser = async () => {

    if (!editMode && !passwordMatch) {
      setNotification({ message: 'A jelszavak nem egyeznek!', type: 'error' });
      return; // Ha a jelszavak nem egyeznek, ne folytassuk a mentést
    }

    setLoading(true); // API hívás előtt beállítjuk a loading állapotot
    const method = editMode ? 'PUT' : 'POST';
    const url = editMode ? `${apiUrl}/users/${selectedUser.id}` : `${apiUrl}/users`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(newUser),
      });

      if (response.ok) {
        const savedUser = await response.json();
        if (editMode) {
          onSaveSuccess(savedUser);
        } else {
          // Itt történik az állapot visszaállítása alapértékre
          setNewUser({ name: '', password: '', fullname: '', email: '', level: 0 });
          setConfirmPassword(''); // Jelszó megerősítés mező törlése
          setNotification({ message: 'Felhasználó tárolása sikeres', type: 'success' });
        }

      } else {
        setNotification({ message: 'Hiba történt a felhasználó mentése során.', type: 'error' });
      }
    } catch (error) {
      setNotification({ message: 'Hálózati hiba történt.', type: 'error' });
    } finally {
      setLoading(false); // API hívás után visszaállítjuk a loading állapotot
    }
  };

  return (
    <div className="create-users">
      <h2>{editMode ? 'Felhasználó szerkesztése' : 'Felhasználó létrehozása'}</h2>

      <div>
        <label>Felhasználó név:</label>
        <input
          type="text"
          placeholder="User name"
          value={newUser.name}
          disabled={editMode}
          onChange={e => setNewUser({ ...newUser, name: e.target.value })}
        />
      </div>
      <div>
        <label>Teljes név:</label>
        <input
          type="text"
          placeholder="User fullname"
          value={newUser.fullname}
          onChange={e => setNewUser({ ...newUser, fullname: e.target.value })}
        />
      </div>
      <div>
        <label>Email cím:</label>
        <input
          type="text"
          placeholder="Email address"
          value={newUser.email}
          onChange={e => setNewUser({ ...newUser, email: e.target.value })}
        />
      </div>
      {/*{editMode && (
        <>
          <div>
            <label>Jelszó:</label>
            <input
              type="password"

              placeholder="Password"
              value={newUser.password}
              onChange={e => setNewUser({ ...newUser, password: e.target.value })}
            />
          </div>
          <div>
            <label>Jelszó megerősítése:</label>
            <input
              type="password"
              placeholder="Confirm password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
            />
            {!passwordMatch && (
              <p style={{ color: 'red' }}>A jelszavak nem egyeznek!</p>
            )}
          </div>
        </>
      )}*/}
      {level > 2 && <div>
        <label>Szint:</label>
        <input
          type="number"
          disabled={editMode && level < 3} // nincs módosítás, ha edit mód
          placeholder="level"
          value={newUser.level}
          onChange={e => setNewUser({ ...newUser, level: e.target.value })}
        />
      </div>}

      <div className="button-group">
        <button
          onClick={onChangePassword}
          style={{
            backgroundColor: '#2fba38ff',
            color: 'white'
          }}
        >
          Jelszó módosítás
        </button>
        <button
          onClick={handleSaveUser}
          disabled={!isFormModified || loading} // Ha nincs módosítás vagy betöltés alatt van, letiltjuk a mentést
          style={{
            marginLeft: '10px',
            backgroundColor: (isFormModified && !loading) ? '#4CAF50' : '#A5D6A7', // Zöld, ha engedélyezett és nem töltődik
            color: 'white',
            cursor: (isFormModified && !loading) ? 'pointer' : 'not-allowed'
          }}
        >
          {loading ? 'Felhasználó mentése...' : (editMode ? 'Felhasználó mentése' : 'Felhasználó felvétele')}
        </button>

        <button
          onClick={onCancel}
          style={{
            backgroundColor: '#f44336', // Piros gomb
            color: 'white',
            marginLeft: '10px'
          }}
        >
          {changedCancelToClose ? 'Bezárás' : 'Mégse'}
        </button>

      </div>
      {/* Notification komponens */}
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: '', type: '' })}
      />


      {isChangePassword && <ChangePassword user={selectedUser} handleLogout={handleClose} />}


    </div>
  );
}

export default CreateUsers;

